import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const socialLinks = [
  {
    name: "Facebook",
    handle: "@steptin",
    url: "https://Facebook.com/steptin",
    icon: "ri-facebook-circle-fill",
    color: "#1877F2",
    bgColor: "#EBF3FF",
    description: "Suivez l'actualité business et les conseils stratégiques",
  },
  {
    name: "X (Twitter)",
    handle: "@steptin",
    url: "https://x.com/steptin",
    icon: "ri-twitter-x-fill",
    color: "#000000",
    bgColor: "#F5F5F5",
    description: "Pensées, tendances et actualités en temps réel",
  },
  {
    name: "Truth Social",
    handle: "@stephaneboutinbusiness",
    url: "https://truthsocial.com/@stephaneboutinbusiness",
    icon: "ri-global-line",
    color: "#FF6B35",
    bgColor: "#FFF3EE",
    description: "Liberté d'expression et contenu exclusif",
  },
  {
    name: "YouTube",
    handle: "@stephane-boutinpointcom",
    url: "https://youtube.com/@stephane-boutinpointcom",
    icon: "ri-youtube-fill",
    color: "#FF0000",
    bgColor: "#FFF0F0",
    description: "Vidéos, formations et contenus éducatifs",
  },
  {
    name: "LinkedIn",
    handle: "Stéphane Boutin",
    url: "https://linkedin.com/in/stephane-boutin-01ba3559/",
    icon: "ri-linkedin-fill",
    color: "#0A66C2",
    bgColor: "#EBF3FF",
    description: "Réseau professionnel et opportunités d'affaires",
  },
  {
    name: "Instagram",
    handle: "@boutin7168",
    url: "https://instagram.com/boutin7168/",
    icon: "ri-instagram-fill",
    color: "#E1306C",
    bgColor: "#FFF0F5",
    description: "Photos, stories et coulisses du quotidien",
  },
];

export default function MediasSociaux() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            (entry.target as HTMLElement).style.opacity = "1";
            (entry.target as HTMLElement).style.transform = "translateY(0)";
          }
        });
      },
      { threshold: 0.1 }
    );
    document.querySelectorAll(".fade-in-up").forEach((el) => {
      (el as HTMLElement).style.opacity = "0";
      (el as HTMLElement).style.transform = "translateY(30px)";
      (el as HTMLElement).style.transition = "opacity 0.7s ease, transform 0.7s ease";
      observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-white" style={{ fontFamily: "'Montserrat', sans-serif" }}>
      <Navbar />

      {/* Header */}
      <section className="pt-32 pb-16 px-6 bg-gray-950 relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <img
            src="https://static.readdy.ai/image/2ff205c826c7478ce4cffa1fe381bc88/e09606e123fa958f68d3144e905b6ce9.jpeg"
            alt=""
            className="w-full h-full object-contain"
          />
        </div>
        <div className="relative z-10 max-w-4xl mx-auto text-center">
          <p className="text-xs font-semibold tracking-[0.3em] uppercase text-amber-500 mb-4">
            Restez connecté
          </p>
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
            Médias sociaux
          </h1>
          <div className="w-12 h-0.5 bg-amber-500 mx-auto mb-6" />
          <p className="text-gray-400 text-base leading-relaxed max-w-xl mx-auto">
            Suivez Stéphane Boutin sur toutes les plateformes pour ne manquer aucun contenu, conseil ou actualité.
          </p>
        </div>
      </section>

      {/* Social Grid */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {socialLinks.map((social, idx) => (
              <a
                key={social.name}
                href={social.url}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="fade-in-up flex flex-col items-center text-center p-8 rounded-lg border border-gray-100 hover:border-gray-200 hover:shadow-lg transition-all duration-300 group cursor-pointer"
                style={{ transitionDelay: `${idx * 0.08}s` }}
              >
                {/* Icon */}
                <div
                  className="w-20 h-20 flex items-center justify-center rounded-full mb-5 group-hover:scale-110 transition-transform duration-300"
                  style={{ backgroundColor: social.bgColor }}
                >
                  <i
                    className={`${social.icon} text-4xl`}
                    style={{ color: social.color }}
                  />
                </div>

                {/* Name */}
                <h2 className="text-base font-bold text-gray-900 mb-1">{social.name}</h2>
                <p className="text-xs text-gray-400 mb-4 font-medium">{social.handle}</p>

                {/* Description */}
                <p className="text-xs text-gray-500 leading-relaxed mb-5">{social.description}</p>

                {/* Link */}
                <span
                  className="inline-flex items-center gap-1.5 text-xs font-semibold px-4 py-2 rounded-full transition-all duration-200"
                  style={{
                    backgroundColor: social.bgColor,
                    color: social.color,
                  }}
                >
                  Suivre
                  <i className="ri-arrow-right-line text-xs" />
                </span>
              </a>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
